export const ACTIVITY_NAME = Object.freeze({
  CALL_PRESCRIBER: "CALL PRESCRIBER",
  CALL_PHARMACY: "CALL PHARMACY",
  CALL_MEMBER: "CALL MEMBER",
});
